var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-alert", { attrs: { show: "" } }, [_vm._v("Default Alert")]),
      _vm._v(" "),
      _c("b-alert", { attrs: { variant: "success", show: "" } }, [
        _vm._v("Success Alert")
      ]),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          attrs: {
            variant: "danger",
            dismissible: "",
            show: _vm.showDismissibleAlert
          },
          on: {
            dismissed: function($event) {
              _vm.showDismissibleAlert = false
            }
          }
        },
        [_vm._v("\n    Dismissible Alert!\n  ")]
      ),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          attrs: {
            show: _vm.dismissCountDown,
            dismissible: "",
            variant: "warning"
          },
          on: {
            dismissed: function($event) {
              _vm.dismissCountDown = 0
            },
            "dismiss-count-down": _vm.countDownChanged
          }
        },
        [
          _c("p", [
            _vm._v(
              "This alert will dismiss after " +
                _vm._s(_vm.dismissCountDown) +
                " seconds..."
            )
          ]),
          _vm._v(" "),
          _c("b-progress", {
            attrs: {
              variant: "warning",
              max: _vm.dismissSecs,
              value: _vm.dismissCountDown,
              height: "4px"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-btn",
        {
          staticClass: "m-1",
          attrs: { variant: "info" },
          on: { click: _vm.showAlert }
        },
        [_vm._v("\n    Show alert with count-down timer\n  ")]
      ),
      _vm._v(" "),
      _c(
        "b-btn",
        {
          staticClass: "m-1",
          attrs: { variant: "info" },
          on: {
            click: function($event) {
              _vm.showDismissibleAlert = true
            }
          }
        },
        [
          _vm._v(
            "\n    Show dismissible alert (" +
              _vm._s(_vm.showDismissibleAlert ? "visible" : "hidden") +
              ")\n  "
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7168fb6a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7168fb6a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ExampleComponent.vue
// module id = 283
// module chunks = 0